<template>

    <div>
        <!-- mobile back to login -->
        <div class="dn-ns dn-m dn-l pa3 bb b--light-gray">
            <BackLink @click="$emit('backClick')">Back to log in</BackLink>
        </div>

        <div class="pa3 flex items-start">

            <!-- left side -->
            <img class="mr3" style="width:100px;" src="@/assets/img/icon_check_black.svg"/>

            <!-- right side -->
            <div>
                <div>If there's a Tooliaba account linked to this email address, we'll send over instructions to reset your password.</div>

                <!-- desktop back to login -->
                <div class="dn dib-ns dib-m dib-l mt3">
                    <BackLink :addCaret="false" @click="$emit('backClick')">Go back to log in</BackLink>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import BackLink from '@/components/controls/BackLink.vue';

export default {
    components: {
        BackLink
    }
};
</script>
